///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>
///<reference path="../../../common/security.keys.ts"/>
///<reference path="../validation/required.validation.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-base.ts"/>

module Meevo.Components.Controls.SmartMover {


    import Dictionary = _.Dictionary;

    export class LocationsGenericDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected locations: SmartMoverCollectionBase<any>;

        public allSelectedLabel: string;
        public totalSelectedMessage: string;
        public title: string;

        get collection() {
            return this.locations;
        }

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions, items: IListElement[] = []) {
            super(model, properties, options.criteria);

            this.locations = new SmartMoverCollectionBase(this.model[properties[0]], items, {
                criteria: options.criteria,
                idKey: 'locationId',
                displayNameKey: 'storeName'
            });
            this.title = 'LABEL_LOCATIONS';
            this.allSelectedLabel = 'LABEL_ALL_LOCATIONS';
            this.totalSelectedMessage = 'LABEL_TOTAL_LOCATIONS_SELECTED';

            if (options.required) {
                this.validation.push(
                    new RequiredValidation(this.locations, 'LABEL_NO_LOCATIONS_ARE_ASSOCIATED')
                );
            }
        }
    }
}
